// src/components/common/ConsoleOverviewCards.tsx

import { Box } from "@mui/material";
import OverviewCard from "./Card/OverviewCard";
import styles from "./ConsoleOverviewCards.module.scss";

export type OverviewCardType = {
	icon: string;
	title: string;
	description: string;
	link: string;
	newTab?: boolean;
};

interface Props {
	cards: OverviewCardType[];
}

const ConsoleOverviewCards = ({ cards }: Props) => {
	return (
		<Box className={styles.cards}>
			{cards.map(({ icon, title, description, link, newTab }, index) => (
				<OverviewCard
					key={index}
					icon={icon}
					title={title}
					description={description}
					link={link}
					newTab={newTab}
				/>
			))}
		</Box>
	);
};

export default ConsoleOverviewCards;
